import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Swal from 'sweetalert2';

const DeleteAccount = () => {
    const [email, setEmail] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isValidEmail, setIsValidEmail] = useState(true);

    useEffect(() => {
        document.title = "Document Repository | Delete Account";;
    }, [window.location.pathname])

    const validateEmail = (email) => {
        return email.match(
            // A simple regex for demonstration; for production use more robust validation
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
        setIsValidEmail(true);
    };



    const handleDeleteClick = () => {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger',
            },
            buttonsStyling: false,
        });

        swalWithBootstrapButtons
            .fire({
                title: 'Are you sure?',
                text: "You want to delete this account",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                reverseButtons: true,
            })
            .then((result) => {
                if (result.isConfirmed) {
                    swalWithBootstrapButtons.fire({
                        title: 'Deleted!',
                        text: 'Your account has been deleted.',
                        icon: 'success',
                    });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    swalWithBootstrapButtons.fire({
                        title: 'Cancelled',
                        text: 'Your account is safe.',
                        icon: 'error',
                    });
                }
            });
    };
    return (
        <section>
            <div className="section-after">
                <div className='container'>
                    <div className="my-5 py-5 row justify-content-center">
                        <div className='col-6'>
                            <div className="card shadow-lg rounded-3 border-0">
                                <div className="border-bottom p-3">
                                    <h3 className="text-center">Account Deletion</h3>
                                </div>
                                {!isSubmitted ? (
                                    <div className="card-body" id="CardBody">
                                        <p className="card-text text-muted fw-semibold w-100">
                                            We appreciate your engagement with My Digital Library and are sorry to hear that you're considering deleting your account. Please note that if you choose to delete your account, the process will take approximately 24 working hours to complete. During this period, your account information will be securely processed and removed from our systems. After the deletion is complete, you are welcome to recreate your account and rejoin the My Digital Library community at any time. We value your presence and hope you reconsider, but if you decide to proceed with the account deletion, we wish you the best and hope to welcome you back in the future.
                                            {/* shortened for brevity */}
                                        </p>
                                        <form className="row g-3 needs-validation" noValidate>
                                            <div className="col-md-12 pt-3">
                                                <input
                                                    type="email"
                                                    className={`form-control ${!isValidEmail ? 'is-invalid' : ''}`}
                                                    id="validationCustom03"
                                                    placeholder="Enter your email"
                                                    required
                                                    value={email}
                                                    onChange={handleEmailChange}
                                                />
                                                <div className="invalid-feedback">
                                                    Please provide a valid email.
                                                </div>
                                            </div>
                                            <p className="card-text text-danger fw-bolder w-100">
                                                <i className="fa-solid fa-triangle-exclamation fs-5 pe-2"></i>
                                                Note* : The process will take approximately 24 working hours to complete.
                                            </p>
                                            <div className="col-12 d-flex justify-content-end ">
                                                <button
                                                    className="btn btn-danger"
                                                    type="button"

                                                    onClick={handleDeleteClick}
                                                >
                                                    Delete My Account
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                ) : (
                                    <div id="Success">
                                        <div className="success-checkmark">
                                            <div className="check-icon">
                                                <span className="icon-line line-tip"></span>
                                                <span className="icon-line line-long"></span>
                                                <div className="icon-circle"></div>
                                                <div className="icon-fix"></div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DeleteAccount
